// removed by extract-text-webpack-plugin
module.exports = {"component":"_3hLLzlcO-iK2KkA7ApEJlX"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Cart/Templates/Hotsite/BannerCenter/bannerCenter.css
// module id = 973
// module chunks = 2